import { designerCanvasStore } from "../stores/designerCanvasStore.ts";
import type { LayerType } from "../types.ts";
import { getLayerTypes } from "../utils/layer.ts";
import { useLayers } from "./useLayers.ts";

export const useSelectedLayerType = (): LayerType | undefined => {
  const layers = useLayers();
  const selectedLayerIds = designerCanvasStore.useState(
    (it) => it.selectedLayerIds,
  );

  const selectedLayers = layers.filter((layer) =>
    selectedLayerIds.includes(layer.id),
  );

  if (selectedLayers.length === 0) return undefined;

  // XXX: If we select multiple layers of the same type, return the layer type. Otherwise, in case of mixed types, we return undefined for now as
  //  the UI doesn't support mixed types yet.
  const layerTypes = getLayerTypes(selectedLayers);

  if (layerTypes.length === 1) return layerTypes[0];

  return undefined;
};
